// Sample articles data for testing enhanced content strategy features
import { ContentfulArticle } from './contentful';

export const sampleArticles: ContentfulArticle[] = [
  {
    id: '1',
    title: 'Advanced Google Analytics 4 Setup for E-commerce',
    slug: 'advanced-ga4-ecommerce-setup',
    excerpt: 'Learn how to configure GA4 for comprehensive e-commerce tracking, including enhanced conversions and attribution modeling.',
    content: 'Complete guide content here...',
    publishDate: '2024-01-15T10:00:00Z',
    tags: ['Google Analytics', 'E-commerce', 'Conversion Tracking', 'Attribution', 'Data Analysis'],
    featuredImage: {
      fields: {
        file: {
          url: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=400&fit=crop'
        },
        title: 'Analytics Dashboard'
      }
    },
    author: {
      sys: { id: 'author-1' },
      fields: {
        name: 'Bemoi George',
        avatar: {
          fields: {
            file: {
              url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
            }
          }
        }
      }
    }
  },
  {
    id: '2',
    title: 'SEO Content Strategy That Actually Converts',
    slug: 'seo-content-strategy-converts',
    excerpt: 'Discover how to create content that ranks well in search engines while driving meaningful conversions for your business.',
    content: 'Complete guide content here...',
    publishDate: '2024-01-10T14:30:00Z',
    tags: ['SEO', 'Content Strategy', 'Conversion Optimization', 'Keyword Research'],
    featuredImage: {
      fields: {
        file: {
          url: 'https://images.unsplash.com/photo-1562577309-2592ab84b1bc?w=800&h=400&fit=crop'
        },
        title: 'SEO Strategy'
      }
    },
    author: {
      sys: { id: 'author-1' },
      fields: {
        name: 'Bemoi George',
        avatar: {
          fields: {
            file: {
              url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
            }
          }
        }
      }
    }
  },
  {
    id: '3',
    title: 'Email Marketing Automation with Mailchimp',
    slug: 'email-marketing-automation-mailchimp',
    excerpt: 'Build sophisticated email marketing funnels that nurture leads and drive sales using Mailchimp\'s automation features.',
    content: 'Complete guide content here...',
    publishDate: '2024-01-05T09:15:00Z',
    tags: ['Email Marketing', 'Marketing Automation', 'Lead Nurturing', 'Mailchimp'],
    featuredImage: {
      fields: {
        file: {
          url: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&h=400&fit=crop'
        },
        title: 'Email Marketing'
      }
    },
    author: {
      sys: { id: 'author-1' },
      fields: {
        name: 'Bemoi George',
        avatar: {
          fields: {
            file: {
              url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
            }
          }
        }
      }
    }
  },
  {
    id: '4',
    title: 'Landing Page Optimization: 15 Elements That Convert',
    slug: 'landing-page-optimization-elements',
    excerpt: 'Analyze the key elements that make landing pages convert, backed by real case studies and A/B testing data.',
    content: 'Complete guide content here...',
    publishDate: '2023-12-28T16:45:00Z',
    tags: ['Landing Pages', 'Conversion Optimization', 'A/B Testing', 'UX Design'],
    featuredImage: {
      fields: {
        file: {
          url: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=400&fit=crop'
        },
        title: 'Landing Page Design'
      }
    },
    author: {
      sys: { id: 'author-1' },
      fields: {
        name: 'Bemoi George',
        avatar: {
          fields: {
            file: {
              url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
            }
          }
        }
      }
    }
  },
  {
    id: '5',
    title: 'Facebook Ads Manager: Advanced Targeting Strategies',
    slug: 'facebook-ads-advanced-targeting',
    excerpt: 'Master Facebook\'s targeting capabilities to reach your ideal customers and maximize your advertising ROI.',
    content: 'Complete guide content here...',
    publishDate: '2023-12-20T11:20:00Z',
    tags: ['Facebook Ads', 'PPC', 'Audience Targeting', 'Social Media Marketing'],
    featuredImage: {
      fields: {
        file: {
          url: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=800&h=400&fit=crop'
        },
        title: 'Facebook Advertising'
      }
    },
    author: {
      sys: { id: 'author-1' },
      fields: {
        name: 'Bemoi George',
        avatar: {
          fields: {
            file: {
              url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
            }
          }
        }
      }
    }
  },
  {
    id: '6',
    title: 'Technical SEO Audit Checklist for 2024',
    slug: 'technical-seo-audit-checklist-2024',
    excerpt: 'Complete technical SEO audit checklist covering Core Web Vitals, structured data, and crawlability issues.',
    content: 'Complete guide content here...',
    publishDate: '2023-12-15T13:10:00Z',
    tags: ['Technical SEO', 'Website Performance', 'Core Web Vitals', 'SEO Audit'],
    featuredImage: {
      fields: {
        file: {
          url: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=800&h=400&fit=crop'
        },
        title: 'Technical SEO'
      }
    },
    author: {
      sys: { id: 'author-1' },
      fields: {
        name: 'Bemoi George',
        avatar: {
          fields: {
            file: {
              url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
            }
          }
        }
      }
    }
  },
  {
    id: '7',
    title: 'Data-Driven Marketing: KPIs That Matter',
    slug: 'data-driven-marketing-kpis',
    excerpt: 'Learn which marketing KPIs actually drive business growth and how to set up proper measurement frameworks.',
    content: 'Complete guide content here...',
    publishDate: '2023-12-08T08:30:00Z',
    tags: ['Data Analysis', 'Marketing KPIs', 'Business Intelligence', 'Performance Marketing'],
    featuredImage: {
      fields: {
        file: {
          url: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=400&fit=crop'
        },
        title: 'Data Analysis'
      }
    },
    author: {
      sys: { id: 'author-1' },
      fields: {
        name: 'Bemoi George',
        avatar: {
          fields: {
            file: {
              url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
            }
          }
        }
      }
    }
  }
];
